module.exports = __webpack_public_path__ + "img/pencil.3bc426d5.svg";